import { createGlobalStyle } from "styled-components";

const GlobalStyle=createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=League+Spartan:wght@100&family=Lobster&family=Nunito+Sans:opsz,wght@6..12,200&family=Poppins:wght@400;500;600;700;800&family=Rubik:wght@300;400;500;600&display=swap');
*{
    margin:0;
    padding:0;
    box-sizing:border-box;
    list-style:none;
    text_decoration:node;
    font-family:'Inter',sans-serif;
}
body{
    background-color: red;
}
`;

export default GlobalStyle;